import dropDownIcon from './img/dropDown/dd.svg';
import dropDownIconActive from './img/dropDown/dd_hover.svg';

const normalShadow = '0 8px 8px 0 rgba(0, 0, 0, 0.24), 0 0 8px 0 rgba(0, 0, 0, 0.12)',
    largeShadow = '0 12px 12px rgba(0, 0, 0, 0.24), 0 20px 40px rgba(0, 0, 0, 0.18)';

const variables = {
    // ссылки, выделенный текст, активные состояния
    tAccent: '#64B22C',
    tWarning: '#F5A623',
    // цвет ошибки
    tError: '#FF635F',
    // цвет заполненного неактивного текста
    tFilled: '#6b7897',
    // цвет label
    tLabel: '#969fb2',
    // цвет текста в активном состоянии
    tActive: 'rgba(0, 0, 0, 1)',
    // второстепенный цвет текста, цвет неактивных иконок
    tInactive: 'rgba(0, 0, 0, 0.54)',
    // цвет подсказок
    tHint: 'rgba(0, 0, 0, 0.38)',
    // placeholder
    tPlaceholder: 'rgba(0, 0, 0, 0.24)',
    // disabled
    tDisabled: 'rgba(0, 0, 0, 0.24)',
    tInversion: '#FFFFFF',

    // фирменный зеленый
    elAccent: '#64B22C',
    // Темное состояние основного цвета для hover эффектов на кнопках, Цвет текстовых ссылок и выделенного текста
    elAccentDark: '#69af25',
    // Светлое состояние основного цвета для pass эффектов на кнопках. Hover цвет для текстовых ссылок
    elAccentLight: '#aee571',
    // фирменный второстепенный, активные состояния
    elSecondaryAccent: '#61b1e7',
    elSecondaryAccentDark: '#217cb5',
    elSecondaryAccentLight: '#97d4ff',
    // фирменный красный
    elError: '#FF635F',
    // фон для ошибки
    elErrorLight: '#ffe6e5',
    // фирменный второстепенный
    elWarning: '#F5A623',
    // основной фон
    elPrimary: '#FFFFFF',
    // hover для светлых фонов
    elPrimaryLight: 'rgba(0, 0, 0, 0.02)',
    // самый светлый фон
    elLightest: 'rgba(0, 0, 0, 0.04)',
    // светлый фон
    elLight: 'rgba(0, 0, 0, 0.08)',
    // темный фон
    elDark: 'rgba(0, 0, 0, 0.12)',
    // самый темный фон
    elDarkest: 'rgba(0, 0, 0, 0.24)',
    elDivider: '#b6b8bd',
    // черный фон (для темной темы)
    elBlack: 'rgba(0, 0, 0, 0.87)',

    // темный фон
    elSecondaryLight: 'rgba(0, 0, 0, 0.38)',
    elSecondary: 'rgba(0, 0, 0, 0.54)',

    // тени
    elShadow: 'rgba(0, 0, 0, 0.16)',
    elShadowMain: '0 8px 8px 0 rgba(0, 0, 0, 0.24)',
    elShadowLight: 'rgba(0, 0, 0, 0.12)',

    // text
    fontFamily: 'Roboto',

    // font weight
    twNormal: 400,
    // light
    twLight: 300,
    // bold
    twBold: 700,
    // semi-bold
    twSemi: 500,

    tsXXSmall: '10px',
    tsXSmall: '12px',
    tsSmall: '14px',
    tsNormal: '16px',
    tsLarge: '20px',
    tsXLarge: '22px',
    tsXXLarge: '24px',

    tlXXSmall: '10px',
    tlXSmall: '20px',
    tlSmall: '22px',
    tlNormal: '24px',
    tlLarge: '28px',
    tlXLarge: '30px',
    tlXXLarge: '32px',

    // gutter width
    gutter: 8,

    transitionDuration: '450ms',

    transitionFunction: 'cubic-bezier(0.23, 1, 0.32, 1)',

    transitionDelay: '0ms',

    mainTransition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1)',

    zMaximal: 1001,
    zOverlay: 999,
};

export const palette = variables;

export default {
    palette: variables,
    ...variables,

    button: {
        palette: variables,
        fontWeight: variables.twSemi,
        borderRadius: '22px',
        paddingTop: '10px',
        paddingBottom: '10px',
        paddingLeft: '44px',
        paddingRight: '44px',
        boxShadow: 'none',
        borderStyle: 'solid',
        borderWidth: 1,
        color: variables.tAccent,
        borderColor: variables.elAccent,
        background: variables.elPrimary,

        focusColor: variables.tAccent,
        focusBorderColor: variables.elAccent,
        focusBackground: variables.elPrimary,
        focusBoxShadow: 'none',

        hoverColor: variables.tAccent,
        hoverBorderColor: variables.elAccent,
        hoverBackground: variables.elPrimary,
        hoverBoxShadow: 'none',

        activeColor: variables.tAccent,
        activeBorderColor: variables.elAccent,
        activeBackground: variables.elPrimary,
        activeBoxShadow: 'none',

        disabledColor: variables.tDisabled,
        disabledBorderColor: variables.elLightest,
        disabledBackground: variables.elLightest,
        disabledBoxShadow: 'none',

        tag: {
            paddingTop: '4px',
            paddingBottom: '4px',
            paddingLeft: '16px',
            paddingRight: '16px',
            borderRadius: '50px',
            background: '#f2f3f3',
            borderWidth: 0,
        },
    },
    input: {
        palette: variables,
        labelColor: variables.tLabel,
        idleBorderColor: variables.elDivider,
        focusBorderColor: variables.elAccent,
        hoverBorderColor: variables.elDivider,
        disabledBorderColor: variables.elDivider,
        lineHeight: 1.25,
    },
    dropDown: {
        palette: variables,
        lineHeight: 1.25,
        labelColor: variables.tLabel,
        appearanceImage: `url("${dropDownIcon}")`,
        appearanceImageHover: `url("${dropDownIconActive}")`,
        listBoxShadow: normalShadow,
        idleBorderColor: variables.elDivider,
        focusBorderColor: variables.elAccent,
        hoverBorderColor: variables.elDivider,
        disabledBorderColor: variables.elDivider,
    },
    toggler: {
        palette: variables,
        lineHeight: 1.25,
        labelColor: variables.tLabel,
    },
    plainText: {
        palette: variables,
        lineHeight: 1.25,
        labelColor: variables.tLabel,
    },
    link: {
        palette: variables,
        inTextTextDecoration: 'underline',
        inTextHoverTextDecoration: 'none',
        color: variables.tFilled,
        hoverColor: variables.tAccent,
    },
    control: {
        palette: variables,
        marginBottom: '32px',
    },
    menu: {
        palette: variables,
        hoverItemColor: variables.tAccent,
    },
    interval: {
        palette: variables,
        background: 'rgba(182, 184, 189, 0.3)',
    },
    table: {
        palette: variables,
        theadThColor: variables.tLabel,
        tbodyThColor: variables.tLabel,
        tfootThColor: variables.tLabel,
    },
    progress: {
        palette: variables,
        progressBackground: 'rgba(0, 0, 0, 0.12)',
    },
};
